import styled from 'styled-components';

import { CrossIcon } from '~/assets';
import { ThemeProp } from '~/theme/Themes';

interface DownloadContainerProps {
  $darkMode?: boolean;
}

export const DownloadContainer = styled.div<DownloadContainerProps>`
  display: flex;
  justify-content: space-between;
  padding: 0.5rem;
  background-color: ${(props: ThemeProp & DownloadContainerProps) =>
    props.$darkMode ? props.theme.colors.neutrals.c800 : props.theme.colors.neutrals.white};
  align-items: center;
  gap: 1rem;
  min-width: 25rem;
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  box-shadow: 0 16px 32px 0 rgba(30, 41, 59, 0.08);
  border: 1px solid ${(props: ThemeProp) => props.theme.colors.neutrals.c100};
  border-radius: 0.5rem;
  color: ${(props: ThemeProp & DownloadContainerProps) =>
    props.$darkMode ? props.theme.colors.neutrals.white : props.theme.colors.neutrals.black};

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.tablet}) {
    bottom: 3rem;
    min-width: unset;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  justify-content: center;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2rem;
  border-radius: 0.375rem;
  width: 2rem;
`;

export const TickContainer = styled(IconContainer)`
  background-color: ${(props: ThemeProp) => props.theme.colors.success};
  stroke: ${(props: ThemeProp) => props.theme.colors.neutrals.white};
`;

export const InformationContainer = styled(IconContainer)`
  background-color: ${(props: ThemeProp) => props.theme.colors.primary.c600};
  stroke: ${(props: ThemeProp) => props.theme.colors.neutrals.white};
`;

export const CrossContainer = styled(IconContainer)`
  background-color: ${(props: ThemeProp) => props.theme.colors.darkRed};
  stroke: ${(props: ThemeProp) => props.theme.colors.neutrals.white};
`;

export const StyledCrossIcon = styled(CrossIcon)`
  stroke: ${(props: ThemeProp) => props.theme.colors.neutrals.c300};
  cursor: pointer;
`;
